import { PubSub } from "@/shared/utils/pubSub";
import { useSubscribe } from "@/shared/utils/useSubscribe";

type Callback = (param: {
    fieldName: string;
    /** Other array paths for the same row that must drop the same position. */
    coupledFieldNames?: string[];
    index: number;
}) => void;

const removeFieldPubSub = new PubSub<Callback>();

export const publishRemoveField = removeFieldPubSub.publish;
export const useOnRemoveField = (callback: Callback) => useSubscribe(removeFieldPubSub, callback);
